import React from 'react';
import type {TaskAssignmentSimpleResponse} from 'src/api/ProactApiClient';
import {TaskTypeEnum} from 'src/api/ProactApiClient';
import {FormSubmissionDrawer} from 'src/app/forms/FormSubmissionDrawer';
import {SideDrawer} from 'src/design/organisms/SideDrawer';
import {ActionPreview} from './ActionPreview';
import {TaskAssignmentPreview} from './TaskAssignmentPreview';

export interface TaskPreviewDrawerProps {
  item: TaskAssignmentSimpleResponse | undefined;
  opened: boolean;
  onClose: () => void;
}

/** Dashboard open-task preview: fill a form task, or act on a talk, approval or action in place. */
export const TaskPreviewDrawer: React.FC<TaskPreviewDrawerProps> = ({
  item,
  opened,
  onClose,
}) => {
  if (!item) {
    return null;
  }

  const {taskType, formDefinitionId} = item.taskDefinition;

  if (taskType === TaskTypeEnum.Form) {
    return formDefinitionId ? (
      <FormSubmissionDrawer
        key={item.id}
        data-testid="task-preview-drawer"
        opened={opened}
        onClose={onClose}
        formDefinitionId={formDefinitionId}
        createOptions={{taskAssignmentId: String(item.id)}}
        formSubmissionId={item.formSubmissionId ?? undefined}
        initialMode={item.formSubmissionId ? 'view' : 'create'}
      />
    ) : null;
  }

  return (
    <SideDrawer data-testid="task-preview-drawer" opened={opened} onClose={onClose}>
      {taskType === TaskTypeEnum.Actions ? (
        <ActionPreview key={item.id} item={item} onClose={onClose} />
      ) : (
        <TaskAssignmentPreview key={item.id} item={item} onClose={onClose} />
      )}
    </SideDrawer>
  );
};
